import { defineComponent, IOmniaShell, ISoilAnalysis, IUibModalScope, selectMany } from "../../../omnia"
import { ISoilAnalysisAllocBindingModel, ISoilService } from "../../../types"
import { AllocPopupBase } from "../alloc-base"


export class SoilAnalysisAllocPopupCtrl extends AllocPopupBase<ISoilAnalysis> {

    static create(): ng.IDirective {

        return defineComponent(SoilAnalysisAllocPopupCtrl, "app/soil/dashboard/alloc/soilanalysis/alloc-popup.html", {
            context: "="
        })

    }

    static $inject = ["$scope", "OmniaSoilService", "OmniaShell"]

    constructor($scope: ng.IScope, private svc: ISoilService, shell: IOmniaShell) {

        super($scope, shell, "soil analysis", true)
        this.$scope = <IUibModalScope>$scope.$parent

        this.field = this.arguments
    }

    $onInit() {
        this.setupAllocations()
    }

    protected setupAllocations() {

        this.availableItems = this.svc
            .getSoilAnalyses()
            .filter(a => !a.ZoneAnalysis)

        this.selectedItems = this.availableItems.filter(s => s.Allocations.filter(a => a.FieldId === this.field.fieldId && !a.ZoneAlloc).length > 0)
        this.availableItems = this.availableItems.filter(a => this.selectedItems.indexOf(a) === -1)

        this.filter()

    }

    protected getDescription(item: ISoilAnalysis): string {
        return item.AnalysisNumber + " - " + item.SamplingDate.toLocaleDateString() + (item.FieldReference ? " - " + item.FieldReference : "")
    }

    commit(): void {

        var existingAllocations = selectMany(this.availableItems.map(s => s.Allocations.filter(a => a.FieldId === this.field.fieldId && !a.ZoneAlloc)))
        var currentAnalysisIds = this.selectedItems.map(a => a.SoilAnalysisId)

        var model = <ISoilAnalysisAllocBindingModel>{
            NewAllocations: currentAnalysisIds.filter(i => existingAllocations.filter(a => a.SoilAnalysisId === i).length === 0).map(i => {
                return {
                    FieldId: this.field.fieldId,
                    AnalysisId: i
                }
            }),
            RemovedAllocations: existingAllocations.filter(a => currentAnalysisIds.indexOf(a.SoilAnalysisId) === -1).map(a => a.SoilAnalysisAllocId)
        }

        if (model.NewAllocations.length || model.RemovedAllocations.length) {
            this.svc.updateSoilAnalysisAlloc(model).then(() => this.cancel())
        } else {
            this.cancel()
        }

    }

}
